import { Box, CircularProgress } from "@mui/material";

const CircularLoading = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default CircularLoading;
